import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as AFFIRM_ICON from '../../../../images/icons/affirm-icon.svg';

class AffirmBlurb extends React.Component {
  get zeroPercentFinancing() {
    return this.props.digitalListing.financing.zero_percent_financing;
  }

  get dialogPath() {
    if (this.zeroPercentFinancing) {
      return '/dialogs/about_affirm_0_financing';
    }
    return '/dialogs/about_affirm';
  }

  get formattedMonthlyPayment() {
    return this.props.digitalListing.financing.estimated_monthly_payment.display;
  }

  get detailsTextTranslation() {
    const zeroPercentFinancing = this.zeroPercentFinancing;
    if (this.zeroPercentFinancing) {
      return I18n.t('digitalListing.affirm.zeroPercentDetails', {
        purchasePrice: this.props.digitalListing.price.display,
        month_1: zeroPercentFinancing.months[0],
        month_2: zeroPercentFinancing.months[1],
        month_3: zeroPercentFinancing.months[2],
        max_months: zeroPercentFinancing.max_months,
      });
    }
    return I18n.t('digitalListing.affirm.details', {
      purchasePrice: this.props.digitalListing.price.display,
    });
  }

  renderSlideout() {
    return (
      <div className="affirm-disclosure mt-half hidden">
        <p className="small mb-half">
          {this.detailsTextTranslation}
        </p>
        <p
          className="strong align-center mb-0"
          dangerouslySetInnerHTML={{
            __html: I18n.t('digitalListing.affirm.selectAtCheckout', {
              affirmLogo: '<span class="affirm-inline-logo affirm-small"></span>',
            }),
          }}
        />
      </div>
    );
  }

  renderZeroPercentFinancing() {
    if (this.zeroPercentFinancing) {
      return (
        <div>
          {I18n.t('digitalListing.affirm.zeroPercentOffer')}
          <br />
        </div>
      );
    }

    return null;
  }

  render() {
    if (!this.props.digitalListing.financing) { return null; }

    return (
      <div className="module module-footer align-center">
        <div
          className="bd-1 bd--offwhite bd-rounded padded align-left"
          data-track-clicks="launch_affirm_lightbox"
        >
          <a data-remote-lightbox="true" href={this.dialogPath} rel="nofollow">
            <div className="g-container">
              <div className="g-col-4">
                <div className="g-container">
                  <div className="g-col-11">
                    <img
                      alt="Affirm icon"
                      className="img-wide"
                      src={AFFIRM_ICON}
                    />
                  </div>
                </div>
              </div>
              <div className="g-col-8">
                <div className="fine-print dark-gray">
                  {I18n.t('digitalListing.affirm.buyWithMonthlyPayments')}
                </div>
                <div className="strong micro-copy uppercase">
                  {I18n.t('digitalListing.affirm.learnMore')}
                </div>
              </div>
            </div>
          </a>
        </div>
        <p className="strong align-center mt-1 mb-0" data-track-clicks="affirm_as_low_as">
          <a data-slideout=".affirm-disclosure" href="#">
            {this.renderZeroPercentFinancing()}
            {
              I18n.t('digitalListing.affirm.asLowAs', {
                monthlyPayment: this.formattedMonthlyPayment,
              })
            }
            <span className="fa fa-angle-down ml-half" />
          </a>
        </p>
        {this.renderSlideout()}
      </div>
    );
  }
}

AffirmBlurb.propTypes = {
  digitalListing: PropTypes.object,
};

export default AffirmBlurb;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/show_page/affirm_blurb.jsx